module.exports = __webpack_public_path__ + "assets/img/s5-tab-1-active-72484f66.png";